// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__z8QMu","info":"Note_info__8i6l8","note":"Note_note__PNP03","actions":"Note_actions__1GXNf"};